export const SET_SIDEBARSHOW = 'SET_SIDEBARSHOW';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_CLIENTSITE = 'SET_CLIENTSITE';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
